module.exports = __webpack_public_path__ + "static/media/chat14.ffa7611e.gif";